<template>

    <div class="w-full">

        <h4 class="mb-3 mt-6">Past sessions</h4>

        <vx-card id="pastSessionsDiv" class="vs-con-loading__container">

            <vs-table :data="sessions" class="mt-3" @selected="openSession">

                <template slot="thead">
                    <vs-th sort-key="timestamp">Start time</vs-th>
                    <vs-th sort-key="duration">Duration</vs-th>
                    <vs-th sort-key="output_type">Output type</vs-th>
                    <vs-th sort-key="checker_enabled">Checker enabled</vs-th>
                    <vs-th sort-key="check_files">Check HLS files</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].timestamp">
                            {{ moment(data[index].timestamp).format("DD/MM/YYYY HH:mm:ss") }}
                        </vs-td>

                        <vs-td :data="data[index].duration">
                            {{ data[index].duration }}
                        </vs-td>

                        <vs-td :data="data[index].output_type">
                            <vs-chip v-if="data[index].output_type === 1" color="#3498db">UDP</vs-chip>
                            <vs-chip v-else-if="data[index].output_type === 2" color="#2ecc71">HLS</vs-chip>
                            <vs-chip v-else-if="data[index].output_type === 3" color="#9b59b6">MPEGTS</vs-chip>
                            <vs-chip v-else color="warning">Unknown</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].checker_enabled">
                            <vs-chip v-if="data[index].checker_enabled" color="success">Yes</vs-chip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].check_files">
                            <vs-chip v-if="data[index].check_files" color="success">Yes</vs-chip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>

        </vx-card>
    </div>

</template>
<script>

    export default {
        props: {
            workerChannelId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                sessions: []
            }
        },
        methods: {
            openSession(tr) {
                this.$router.push('/worker_channel/' + this.workerChannelId + '/session/' + tr.id)
            },
            loadData() {
                this.$vs.loading({
                    container: '#pastSessionsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker_channel/' + this.workerChannelId + '/session')
                loadPromise.then(function(response) {
                    thisIns.sessions = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#pastSessionsDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            this.loadData()
        }

    }

</script>
